<template>
  <div class="left" :class="{ active: !logoShow }">
    <div class="inner">
      <div class="nav">
        <div class="menu" v-if="logoShow">
          <div
            class="menuList"
            :class="{ active: Pindex == pItem.id }"
            v-for="(pItem, i) in downList"
            :key="i"
            @click="changeTabs(pItem.id)"
          >
            <img :src="pItem.img" width="28px" height="28px" alt=""/>
            <span>{{ pItem.title }}</span>
          </div>

          <el-collapse accordion v-model="activeName" v-if="Pindex == 1">
            <el-collapse-item
              v-for="(item, t) in Service"
              :key="t"
              :name="item.id + ''"
            >
              <template slot="title">
                <img
                  v-if="item.meta.icon != null || item.meta.icon != ''"
                  :src="require('../../assets/img/' + item.meta.icon)"
                  width="31px"
                  height="34px"
                  alt=""
                />
                <span>{{ item.meta.title }}</span>
              </template>
              <div class="item">
                <div
                  class="list"
                  v-for="(child, index) in item.children"
                  :key="index"
                  @click="changeChild(child.id, child.path, child.area)"
                >
                  <img
                    v-if="child.meta.icon != null || item.meta.icon != ''"
                    :src="require('../../assets/img/' + child.meta.icon)"
                    width="46px"
                    height="46px"
                    alt=""
                  />

                  <span :class="{ actives: num == child.id }">
                    {{ child.meta.title }}
                  </span>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <!-- 基础信息 -->
          <el-collapse accordion v-model="Pindex" v-else>
            <el-collapse-item
              v-for="(item, t) in Basic"
              :key="t"
              :name="item.id + ''"
            >
              <template slot="title">
                <img
                  :src="require('../../assets/img/' + item.meta.icon)"
                  width="31px"
                  height="34px"
                  alt=""
                />
                <span>{{ item.meta.title }}</span>
              </template>
              <div class="item1">
                <div
                  class="list"
                  :class="{ actives: num == child.id }"
                  v-for="(child, index) in item.children"
                  :key="index"
                  @click="changeChild(child.id, child.path, child.area)"
                >
                  <img
                    :src="require('../../assets/img/' + child.meta.icon)"
                    width="46px"
                    height="46px"
                    alt=""
                  />
                  <span>{{ child.meta.title }}</span>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <div class="menu2" v-else>
          <div
            class="li"
            v-for="(li, lindex) in showList.children"
            :key="lindex"
            @click="changeChild(li.id, li.path, li.area)"
          >
            <img
              :src="require('../../assets/img/' + li.meta.icon)"
              width="46px"
              height="46px"
              alt=""
            />
            <span :class="{ actives: num == li.id }">
              {{ li.meta.title }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Signal from "../../assets/js/signal.js";
import qs from "qs";

export default {
  name: "navbar",
  data() {
    return {
      bgColor: "",
      roles: 0,
      routerList: [],
      isv20: "",

      downList: [
        {
          img: require(`../../assets/img/sy_cjl_fwmk.png`),
          title: "服务模块",
          id: "1",
        },
        {
          img: require(`../../assets/img/sy_cjl_jcxx.png`),
          title: "基础信息",
          id: "4",
        },
        {
          img: require(`../../assets/img/sy_cjl_gzgf.png`),
          title: "工作规范",
          id: "47",
        },
        {
          img: require(`../../assets/img/sy_cjl_sz.png`),
          title: "设置",
          id: "54",
        },
      ],
      Pindex: "1",
      list: [],

      Service: [],
      Basic: [],
      Work: [],
      SetUp: [],
      activeName: "1",
      num: "",

      logoShow: true,
      showList: [],

      schoolId: JSON.parse(localStorage.getItem("userInfo")).kinderGartenId,
    };
  },
  mounted() {
    this.getMenuList();

    var ts = this;
    Signal.$on("logoMenu", function (res) {
      // console.log("nav", res);
      ts.logoShow = res;
      if (res) {
        ts.showMenu();
      } else {
        ts.showMenu();
      }
    });
  },
  methods: {
    getMenuList() {
      // console.log(JSON.parse(localStorage.getItem("userInfo")).menuList);
      let data = JSON.parse(localStorage.getItem("userInfo")).menuList;
      if (this.Pindex == 1) {
        this.Service = data.filter(
          (item) =>
            item.id != 4 &&
            item.id != 47 &&
            item.id != 54 &&
            item.id != 8 &&
            item.id != 95
        );
      } else if (this.Pindex == 4) {
        this.Basic = data.filter((item) => item.id == 4 || item.id == 8);
      } else if (this.Pindex == 47) {
        this.Basic = data.filter((item) => item.id == 47);
      } else {
        this.Basic = data.filter((item) => item.id == 54 || item.id == 95);
      }
      this.changePage();
    },
    changeTabs(tabs) {
      this.Pindex = tabs;
      this.activeName = tabs;
      this.getMenuList();
    },
    changeChild(id, path, name) {
      // console.log('path',path)
      // console.log(name);
      if (this.Pindex == 1 || this.Pindex == 4) {
        if (path != this.$route.path) {
          this.axios
            .post(
              "/useApi/User/PcRecordUse",
              qs.stringify({platform: "pc", Page: name || 'other'})
            )
            .then((res) => {
              if (res.data.resultType == 0) {
                // console.log(res.data.message);
              } else {
                console.warn(res.data.message);
              }
            })
            .catch((err) => this.$alert(err));
        }
      }
      if (path == "/datas") {
        this.goUrl("dvDB13eXGflIPnr8e2Br-8FfvHV0r_h7");
        // window.open(
        //   "https://datav.aliyuncs.com/share/dd307e3f2c87640ab166aa70a608e9dd?schoolId=" +
        //     this.schoolId,
        //   "_blank"
        // );
        // window.location.href =
        //   "https://datav.aliyuncs.com/share/dd307e3f2c87640ab166aa70a608e9dd?schoolId=" +
        //   this.schoolId;
      } else if (path == '/healthReports/kReport') {
        window.open('/#/healthReports/kReport', '_blank')
      } else {
        this.num = id;
        this.$router.push(path);
      }
    },
    goUrl(tokens) {
      // https://datav.aliyuncs.com/share/9c53e59fe67e5dbeae56eb665d77d504
      //  token  // 4ig3542mR4cX4jtWLMSanBpUSFfldI5L

      const crypto = require("crypto");
      const querystring = require("querystring");
      const signedQueryParamReg = /^datav_sign_.*/; // 符合此正则表达式的参数是需要签名的。

      const token = tokens;
      const screenID = "dd307e3f2c87640ab166aa70a608e9dd";
      const time = Date.now();

      const customeParams = {
        datav_sign_no: 123998,
        name: 123,
      };
      let signParamsStr = Object.keys(customeParams)
        .filter(
          (paramName) =>
            customeParams[paramName] && signedQueryParamReg.test(paramName)
        )
        .sort()
        .map((param) => `${param}=${customeParams[param]}`)
        .join("&");
      let stringToSign = [screenID, time];
      signParamsStr && stringToSign.push(signParamsStr);
      stringToSign = stringToSign.join("|");
      let signature = crypto
        .createHmac("sha256", token)
        .update(stringToSign)
        .digest()
        .toString("base64");
      let queryParams = {
        _datav_time: time,
        _datav_signature: signature,
        schoolId: this.schoolId,
      };

      Object.keys(customeParams).forEach((paramName) => {
        queryParams[paramName] = customeParams[paramName];
      });

      let dataVurl = `https://b.datav.run/share/${screenID}?${querystring.stringify(
        queryParams
      )}`;

      // console.log(this.dataVurl);
      window.open(dataVurl, "_blank");
    },
    changePage() {
      if (this.Pindex == 1) {
        // console.log(this.$route.path);
        this.Service.forEach((item) => {
          item.children.forEach((child) => {
            if (child.path == this.$route.path) {
              this.activeName = item.id + "";
              this.num = child.id;

              this.axios
                .post(
                  "/useApi/User/PcRecordUse",
                  qs.stringify({platform: "pc", Page: child.area})
                )
                .then((res) => {
                  if (res.data.resultType == 0) {
                    // console.log(res.data.message);
                  } else {
                    console.warn(res.data.message);
                  }
                })
                .catch((err) => this.$alert(err));
            } else if (this.$route.path == '/classHome/0') {
              this.num = 108
              this.Pindex = 1;
              this.activeName = '66';
            }
          });
        });
      } else {
        this.Basic.forEach((item) => {
          item.children.forEach((child) => {
            if (child.path == this.$route.path) {
              this.activeName = item.id + "";
              this.num = child.id;
            }
          });
        });
      }
    },
    showMenu() {
      if (this.Pindex == 1) {
        this.Service.map((item) => {
          item.children.map((child) => {
            if (child.path == this.$route.path) {
              this.activeName = item.id + "";
              this.num = child.id;
              this.showList = item;
              return;
            }
          });
        });
        // console.log("show", this.showList);
      } else {
        // console.log(this.$route.path);
        this.Basic.map((item) => {
          item.children.map((child) => {
            if (child.path == this.$route.path) {
              this.activeName = item.id + "";
              this.num = child.id;
              this.showList = item;
              return;
            }
          });
        });
        // console.log("show1", this.showList);
      }
    },
  },
  watch: {
    '$route'(to, from) {
      if (to.path == '/classHome/0') {
        this.num = 108
        this.Pindex = 1;
        this.activeName = '66';
      }
    },
  },
};
</script>

<style scoped lang="less">
.left {
  width: 286px;
  position: absolute;
  top: 72px;
  left: 0;
  height: calc(100% - 72px);
  box-shadow: 0 6px 9px rgb(165, 159, 159);
  z-index: 9;

  .inner {
    width: 286px;
    height: 100%;
    background: #fbfbfb;
    // overflow-x: hidden;
    .nav {
      width: 286px;
      height: 100%;
      // overflow-y: scroll;
    }
  }

  &.active {
    width: 95px;

    .inner {
      width: 100%;
      height: 100%;
      background: #fbfbfb;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 5px;
        height: 1px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: none;
        background: #bebebe;
        -webkit-box-shadow: none;
      }

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: none;
        border-radius: 10px;
        background: #f2f2f2;
        -webkit-box-shadow: none;
      }

      .nav {
        width: 100%;
        height: 100%;

        .menu2 {
          padding-top: 10px;

          .li {
            text-align: center;
            padding: 10px 0;

            img {
              margin: 0 auto 5px;
            }

            span {
              display: inline-block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              width: 68px;
              font-size: 14px;
            }

            .actives {
              background: #3fbe3c;
              color: #fff;
              width: 70px;
              border-radius: 50px;
              padding: 2px 6px;
            }
          }
        }
      }
    }
  }
}

.menu {
  height: 100%;

  .menuList {
    display: inline-block;
    padding: 10px 0;
    position: absolute;
    bottom: 0;
    background: #fbfbfb;
    border-top: 1px solid #f2f2f2;
    width: 25%;
    text-align: center;
    cursor: pointer;

    img {
      margin: 0 auto;
    }

    span {
      font-size: 12px;
    }

    &:nth-child(1) {
      left: 0;
    }

    &:nth-child(2) {
      left: 25%;
    }

    &:nth-child(3) {
      left: 50%;
    }

    &:nth-child(4) {
      right: 0;
    }

    &.active {
      background: #fff;
    }
  }
}

.item {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  background: #fbfbfb;

  .list {
    margin: 8px 10px 10px;
    text-align: center;
    width: 65px;
    cursor: pointer;

    img {
      margin: 0 auto;
    }

    span {
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 68px;
      font-size: 12px;
    }

    .actives {
      background: #3fbe3c;
      color: #fff;
      width: 70px;
      border-radius: 50px;
      padding: 2px 6px;
    }
  }
}

.item1 {
  background: #fbfbfb;

  .list {
    padding: 10px;
    cursor: pointer;

    img {
      margin-left: 10px;
    }

    img,
    span {
      display: inline-block;
      vertical-align: middle;
    }

    &.actives {
      border-left: 3px solid #3fbe3c;
      background: #fff;
    }
  }
}

/deep/ .el-collapse {
  height: calc(100% - 71px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: none;
    background: #bebebe;
    -webkit-box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    border-radius: 10px;
    background: #f2f2f2;
    -webkit-box-shadow: none;
  }

  .el-collapse-item {
    .el-collapse-item__header {
      // padding-left: 20px;
      padding: 30px 0 30px 28px;
      background: #fff;
      font-size: 15px;

      img {
        margin-right: 10px;
      }
    }

    .el-collapse-item__wrap {
      border-top: 1px solid #ebeef5;

      .el-collapse-item__content {
        // padding-top: 10px;
        padding-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar.vue